import { gql, useMutation } from "@apollo/client";
import React, { useState } from "react";
import {
  BreadCrumb,
  BreadCrumbProp,
} from "../../../components/light/Breadcrumb";
import { Content } from "../../../components/light/Content";
import { SectionBlock } from "../../../components/light/SectionBlock";

const BreadCrumbItems: BreadCrumbProp[] = [
  { text: "applications", to: "#" },
  { text: "Tracking Number", to: "/applications/tracking" },
];

const MUTATION = gql`
  mutation attachShipmentTrackingCode(
    $trackingCode: String!
    $reference: String!
  ) {
    attachShipmentTrackingCode(
      trackingCode: $trackingCode
      reference: $reference
    )
  }
`;

export function InventoryTrackingScreen() {
  const [tracking, setTracking] = useState(localStorage.getItem("tracking"));
  const [trackingInput, setTrackingInput] = useState("");
  const [barcodes, setBarcodes] = useState<any>(
    localStorage.getItem("barcode")
      ? JSON.parse(localStorage.getItem("barcode")!)
      : []
  );
  const [barcodeInput, setBarcodeInput] = useState("");
  const [attachShipmentTrackingCode] = useMutation(MUTATION, {
    refetchQueries: ["merchantShipmentList"],
    onCompleted: (res) => {
      let data = barcodes;
      data[data.findIndex((x: any) => x.label === barcodeInput)].success =
        res.attachShipmentTrackingCode;
      data[
        data.findIndex((x: any) => x.label === barcodeInput)
      ].loading = false;
      setBarcodes(data);
      setBarcodeInput("");
      localStorage.setItem("barcode", JSON.stringify(data));
    },
  });

  const hadleEnterTrackingNumber = (
    e: React.KeyboardEvent<HTMLInputElement>
  ) => {
    if (e.keyCode === 13) {
      localStorage.setItem("tracking", trackingInput);
      setTracking(trackingInput);
    }
  };

  const handleBack = () => {
    localStorage.removeItem("tracking");
    localStorage.removeItem("barcode");
    setBarcodes([]);
    setTrackingInput("");
    setTracking("");
  };

  const handleEnterBarcode = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.keyCode === 13) {
      let data = [
        { label: barcodeInput, success: false, loading: true },
        ...barcodes,
      ];
      localStorage.setItem("barcode", JSON.stringify(data));
      setBarcodes(data);
      attachShipmentTrackingCode({
        variables: {
          trackingCode: tracking,
          reference: barcodeInput,
        },
      });
    }
  };

  return (
    <Content breadcrumb={<BreadCrumb items={BreadCrumbItems} />}>
      <div className="row">
        <div className="col-md-4">
          {!tracking ? (
            <SectionBlock title="Tracking Number" transparent={true}>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control form-secondary"
                  placeholder="Tracking number"
                  value={trackingInput}
                  onChange={(e) => setTrackingInput(e.target.value)}
                  onKeyDown={hadleEnterTrackingNumber}
                />
                <small className="help-block form-text text-muted form-control-feedback">
                  Press <code>Enter</code> to continue
                </small>
              </div>
            </SectionBlock>
          ) : (
            <SectionBlock title={tracking} transparent={true}>
              <div className="form-group">
                <label>Barcode shipment or order</label>
                <input
                  type="text"
                  className="form-control form-secondary"
                  placeholder="Enter barcode"
                  value={barcodeInput}
                  onChange={(e) => setBarcodeInput(e.target.value)}
                  onKeyDown={handleEnterBarcode}
                />
              </div>
              <div className="text-right">
                <button className="btn btn-primary btn-sm" onClick={handleBack}>
                  Let go to next tracking number
                </button>
              </div>
              <br />
              <table className="table table-padded">
                <tbody>
                  {barcodes.map((x: any, i: number) => {
                    return (
                      <tr key={i}>
                        <td style={{ width: 50 }}>
                          {!x.loading ? (
                            x.success ? (
                              <div
                                className="text-success os-icon os-icon-ui-21"
                                style={{ fontSize: 20 }}
                              ></div>
                            ) : (
                              <div
                                className="text-danger os-icon os-icon-alert-circle"
                                style={{ fontSize: 20 }}
                              ></div>
                            )
                          ) : (
                            <div
                              className="spinner-border text-primary spinner-border-sm"
                              role="status"
                            >
                              <span className="visually-hidden"></span>
                            </div>
                          )}
                        </td>
                        <td>{x.label}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </SectionBlock>
          )}
        </div>
      </div>
    </Content>
  );
}
